export function formatPhone(phoneNumber: string) {
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    if (cleaned.length === 10) {
        return `(${cleaned.slice(0,3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`
    } else if (cleaned.length === 11) {
        return `${cleaned.slice(0, 1)} (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`
    }

    return phoneNumber;
};

export const formatPhoneLink = (phoneNumber: string) => {
    const cleaned = phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
    console.log('CLEANED NUMBER:', cleaned);
    return cleaned;
};